import { useSlate } from "slate-react";
import { Button, Icon } from "../StaleComponents";
import React from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { Popover } from "@mantine/core";
import { wrapEmoji } from "../utils/emojiWraps";

export const AddEmojiButton = () => {
  const editor = useSlate();

  return (
    <>
      <Popover width={"dropdown"} position="bottom" offset={-15}>
        <Popover.Target>
          <Button>
            <Icon>mood</Icon>
          </Button>
        </Popover.Target>
        <Popover.Dropdown
          style={{ background: "transparent", borderColor: "transparent" }}
        >
          <Picker
            data={data}
            onEmojiSelect={(emoji) => wrapEmoji(editor, emoji.native)}
          />
        </Popover.Dropdown>
      </Popover>
      {/*{showEmoji && }*/}
    </>
  );
};
